import React, {FunctionComponent} from 'react';
import styled from "styled-components";
import "./SmallButton.scss";
import {Button} from "../Button/Button";

interface SmallButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {

}

const StyledSmallButton = styled(Button)``;

export const SmallButton: FunctionComponent<SmallButtonProps> = (props) => {

    return (
        <StyledSmallButton {...props} className={`${props.className} small-button`} />
    );
}